import { createCenterlinePlaneUpdater, setCenterlinePlanes } from "../../../../src/RAWMap.Client/Visualization/CenterlineMeasurement/CenterlinePlaneHooks.js";
import { Visualization_Centerline } from "../../RAWMap.Models/Common.js";
import { newGuid } from "../../fable_modules/fable-library-js.4.19.3/Guid.js";
import { Bindings_PlaneIdentifier } from "../../RAWMap.Models/View/CenterlineMeasurement.js";
import { CenterlinePlane } from "../CenterlineMeasurement/CenterlineMeasurementBindings.js";
import { ArrayNames_fieldDataArrayNames, ArrayNames_pointDataArrayNames } from "../CenterlineMeasurement/CenterlineMeasurementCoreTypes.js";
import { exactlyOne } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { SliceCenterlinePlane } from "./SlicePlaneBindings.js";
import { LocalMsg, ModelSlicePlane } from "./SlicePlaneTypes.js";
import { Cmd_none } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { maxBy, minBy, singleton, ofArray } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { round, comparePrimitives } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { convertUnifiedBranchIndexToMasterIndex } from "../../../../src/RAWMap.Client/Visualization/CenterlineMeasurement/CenterlinePlaneShared.js";
import { CenterlineBranchSelection } from "../../../../src/RAWMap.Client/Visualization/CenterlineMeasurement/CenterlinePlaneShared.js";
import { defaultArg, some, map } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { DicomViewMode_get_describe } from "../Common/CommonTypes.js";
import { update as update_1 } from "../../Common/InboundOutbound.js";

export function mkPipelines(updater, branch, index) {
    return setCenterlinePlanes(updater, [new CenterlinePlane(new Visualization_Centerline(1, []), branch, index, newGuid(), new Bindings_PlaneIdentifier(0, []))]);
}

export function initializeCenterlinePlane(meshes, branch) {
    const updater = createCenterlinePlaneUpdater(meshes, ArrayNames_pointDataArrayNames, ArrayNames_fieldDataArrayNames, (value) => {
    });
    return new SliceCenterlinePlane(exactlyOne(mkPipelines(updater, branch, 0)), updater);
}

export function init(viewMode) {
    return [new ModelSlicePlane((viewMode.tag === 5) ? 0.1 : ((viewMode.tag === 6) ? 0.1 : ((viewMode.tag === 0) ? undefined : ((viewMode.tag === 1) ? undefined : ((viewMode.tag === 2) ? undefined : ((viewMode.tag === 3) ? undefined : 0.1))))), undefined, false, false, false, undefined, viewMode, undefined, undefined, undefined), Cmd_none()];
}

export function computeCenterlineSliceIndexes(meshes, centerlinePlane, branch, newIdx) {
    const branchIndexBounds = centerlinePlane.CenterlinePlaneUpdater.getUnifiedBranchIndexBounds().wallBounds;
    const validBounds = (branch.tag === 1) ? ((branch.fields[0].tag === 1) ? ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceRightBranch]) : ((branch.fields[0].tag === 2) ? singleton(branchIndexBounds.distanceTrunkCusp) : ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceLeftBranch]))) : ((branch.fields[0].tag === 1) ? ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceRightBranch]) : ((branch.fields[0].tag === 2) ? singleton(branchIndexBounds.distanceTrunkCusp) : ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceLeftBranch])));
    const minValue = minBy((b) => b.firstIndex, validBounds, {
        Compare: comparePrimitives,
    });
    const maxValue = maxBy((b_1) => b_1.lastIndex, validBounds, {
        Compare: comparePrimitives,
    });
    const clampedValue = ((newIdx < minValue.firstIndex) ? minValue.firstIndex : ((newIdx > maxValue.lastIndex) ? maxValue.lastIndex : newIdx)) | 0;
    return [clampedValue, convertUnifiedBranchIndexToMasterIndex(clampedValue, CenterlineBranchSelection.ofBranchSelection(branch), meshes.wallCenterline.dataSource.getFieldData()) + 0.1];
}

export function updateInbound(unitVar, msg, model) {
    switch (msg.tag) {
        case 1:
            return [new ModelSlicePlane(map((idx) => (idx + msg.fields[0]), model.Index), model.MaxIndex, model.IsVisible, model.IsHovering, model.IsDisabled, model.Bounds, model.DicomViewMode, model.MaybeCenterlinePlane, model.MaybeMeshes, model.MaybeUnifiedBranchIndex), Cmd_none(), Cmd_none()];
        case 2:
            return [new ModelSlicePlane(model.Index, model.MaxIndex, model.IsVisible, msg.fields[0], model.IsDisabled, model.Bounds, model.DicomViewMode, model.MaybeCenterlinePlane, model.MaybeMeshes, model.MaybeUnifiedBranchIndex), Cmd_none(), Cmd_none()];
        case 3:
            return [new ModelSlicePlane(model.Index, model.MaxIndex, model.IsVisible, model.IsHovering, msg.fields[0], model.Bounds, model.DicomViewMode, model.MaybeCenterlinePlane, model.MaybeMeshes, model.MaybeUnifiedBranchIndex), Cmd_none(), Cmd_none()];
        case 4:
            return [model, singleton((dispatch) => {
                dispatch(new LocalMsg(msg.fields[0]));
            }), Cmd_none()];
        case 5: {
            const maybeMeshes = msg.fields[1];
            const maybeIndex = msg.fields[2];
            const dicomView = msg.fields[0];
            const matchValue = model.DicomViewMode;
            const matchValue_1 = model.MaybeCenterlinePlane;
            let matchResult, branch, centerlinePlane, meshes, branch_1, meshes_1;
            switch (dicomView.tag) {
                case 5: {
                    if (maybeMeshes == null) {
                        matchResult = 2;
                    }
                    else if (matchValue.tag === 5) {
                        if (matchValue_1 != null) {
                            matchResult = 0;
                            branch = dicomView.fields[0];
                            centerlinePlane = matchValue_1;
                            meshes = maybeMeshes;
                        }
                        else {
                            matchResult = 1;
                            branch_1 = dicomView.fields[0];
                            meshes_1 = maybeMeshes;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                case 6: {
                    if (maybeMeshes == null) {
                        matchResult = 2;
                    }
                    else if (matchValue.tag === 6) {
                        if (matchValue_1 != null) {
                            matchResult = 0;
                            branch = dicomView.fields[0];
                            centerlinePlane = matchValue_1;
                            meshes = maybeMeshes;
                        }
                        else {
                            matchResult = 1;
                            branch_1 = dicomView.fields[0];
                            meshes_1 = maybeMeshes;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                case 0: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
            switch (matchResult) {
                case 0: {
                    const updatedIndex = ((maybeIndex != null) ? maybeIndex : ~~centerlinePlane.PlanePipeline.centerlinePlaneSource.planeIndexFilter.getCurrentIdx()) | 0;
                    const updatedCenterlinePlane = new SliceCenterlinePlane(exactlyOne(mkPipelines(centerlinePlane.CenterlinePlaneUpdater, branch, updatedIndex)), centerlinePlane.CenterlinePlaneUpdater);
                    const patternInput = computeCenterlineSliceIndexes(meshes, centerlinePlane, branch, updatedIndex);
                    return [new ModelSlicePlane(patternInput[1], model.MaxIndex, model.IsVisible, model.IsHovering, model.IsDisabled, model.Bounds, dicomView, updatedCenterlinePlane, maybeMeshes, [branch, patternInput[0]]), Cmd_none(), Cmd_none()];
                }
                case 1: {
                    const centerlinePlane_1 = initializeCenterlinePlane(meshes_1, branch_1);
                    const patternInput_1 = computeCenterlineSliceIndexes(meshes_1, centerlinePlane_1, branch_1, (maybeIndex != null) ? maybeIndex : ~~centerlinePlane_1.PlanePipeline.centerlinePlaneSource.planeIndexFilter.getCurrentIdx());
                    const clampedIndex_1 = patternInput_1[0] | 0;
                    centerlinePlane_1.PlanePipeline.centerlinePlaneSource.planeIndexFilter.setCurrentIdx(clampedIndex_1);
                    return [new ModelSlicePlane(patternInput_1[1], model.MaxIndex, model.IsVisible, model.IsHovering, model.IsDisabled, model.Bounds, dicomView, centerlinePlane_1, maybeMeshes, [branch_1, clampedIndex_1]), Cmd_none(), Cmd_none()];
                }
                case 2: {
                    console.warn(some("Centerline slice plane view mode requested without providing meshes"));
                    return [model, Cmd_none(), Cmd_none()];
                }
                case 3:
                    return [new ModelSlicePlane((maybeIndex != null) ? maybeIndex : model.Index, model.MaxIndex, model.IsVisible, model.IsHovering, model.IsDisabled, model.Bounds, dicomView, undefined, model.MaybeMeshes, model.MaybeUnifiedBranchIndex), Cmd_none(), Cmd_none()];
                default: {
                    console.warn(some("Requested slice plane view mode not supported:"), dicomView);
                    return [model, Cmd_none(), Cmd_none()];
                }
            }
        }
        case 6: {
            const matchValue_3 = model.DicomViewMode;
            const matchValue_4 = model.MaybeCenterlinePlane;
            const matchValue_5 = model.MaybeMeshes;
            let matchResult_1, branch_2, centerlinePlane_2, meshes_2;
            switch (matchValue_3.tag) {
                case 5: {
                    if (matchValue_4 == null) {
                        matchResult_1 = 1;
                    }
                    else if (matchValue_5 == null) {
                        matchResult_1 = 2;
                    }
                    else {
                        matchResult_1 = 0;
                        branch_2 = matchValue_3.fields[0];
                        centerlinePlane_2 = matchValue_4;
                        meshes_2 = matchValue_5;
                    }
                    break;
                }
                case 6: {
                    if (matchValue_4 == null) {
                        matchResult_1 = 1;
                    }
                    else if (matchValue_5 == null) {
                        matchResult_1 = 2;
                    }
                    else {
                        matchResult_1 = 0;
                        branch_2 = matchValue_3.fields[0];
                        centerlinePlane_2 = matchValue_4;
                        meshes_2 = matchValue_5;
                    }
                    break;
                }
                default:
                    matchResult_1 = 3;
            }
            switch (matchResult_1) {
                case 0: {
                    const roundedDelta = ~~round(msg.fields[0]) | 0;
                    const patternInput_2 = computeCenterlineSliceIndexes(meshes_2, centerlinePlane_2, branch_2, defaultArg(map((tuple) => tuple[1], model.MaybeUnifiedBranchIndex), 0) + roundedDelta);
                    const clampedValue = patternInput_2[0] | 0;
                    centerlinePlane_2.PlanePipeline.centerlinePlaneSource.planeIndexFilter.setCurrentIdx(clampedValue);
                    return [new ModelSlicePlane(patternInput_2[1], model.MaxIndex, model.IsVisible, model.IsHovering, model.IsDisabled, model.Bounds, model.DicomViewMode, model.MaybeCenterlinePlane, model.MaybeMeshes, [branch_2, clampedValue]), Cmd_none(), Cmd_none()];
                }
                case 1: {
                    console.warn(some("IncrementIndex called but model.MaybeCenterlinePlane is None"));
                    return [model, Cmd_none(), Cmd_none()];
                }
                case 2: {
                    console.warn(some("IncrementIndex called but model.MaybeMeshes is None"));
                    return [model, Cmd_none(), Cmd_none()];
                }
                default: {
                    console.warn(some(`IncrementIndex only expected in a centerline view mode (current mode is ${DicomViewMode_get_describe()(model.DicomViewMode)})`));
                    return [model, Cmd_none(), Cmd_none()];
                }
            }
        }
        default: {
            const value = msg.fields[0];
            return [new ModelSlicePlane(value.index, value.maxIndex, model.IsVisible, model.IsHovering, model.IsDisabled, value.bounds, model.DicomViewMode, model.MaybeCenterlinePlane, model.MaybeMeshes, model.MaybeUnifiedBranchIndex), Cmd_none(), Cmd_none()];
        }
    }
}

export function updateLocal(unitVar, msg, model) {
    return [new ModelSlicePlane(model.Index, model.MaxIndex, msg.fields[0], model.IsHovering, model.IsDisabled, model.Bounds, model.DicomViewMode, model.MaybeCenterlinePlane, model.MaybeMeshes, model.MaybeUnifiedBranchIndex), Cmd_none(), Cmd_none()];
}

export function update(msg, model) {
    return update_1((arg00$0040, msg_1, model_1) => updateLocal(undefined, msg_1, model_1), (arg00$0040_1, msg_2, model_2) => updateInbound(undefined, msg_2, model_2), undefined, msg, model);
}

